<template>
	<div v-if="user === 'client'">
        <div v-if="$route.name === 'account.profile.personal-information'">
			<client-account-profile-nav-component/>
		</div>
		<div v-else>
			<client-company-profile-nav-component/>
		</div>

        <router-view/>
	</div>

	<div v-else>
		<router-view/>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				user: this.$store.getters.user.type
			};
		}
	};
</script>